var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('faf-card',{attrs:{"name":"purchase-order-history","initial-collapsed":"","title":"Ostutellimuste ajalugu"}},[_c('faf-purchase-history')],1)}
var staticRenderFns = []

export { render, staticRenderFns }